import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import styled from "styled-components";

import isEmail from "validator/lib/isEmail";

import { Input, NextStepButton, InputError, Logo } from "components";

import { UPDATE_INPUT, MOVE_TAB } from "actions";

const Switch = styled.label`
  position: relative;
  width: 60px;
  height: 34px;
  input {
    display: none;
  }
  input:checked + .slider {
    background-color: ${props => props.bg};
  }
  input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }
  input:checked + .slider:before {
    transform: translateX(26px);
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;
    &:before {
      border-radius: 50%;
      position: absolute;
      content: "";
      height: 26px;
      width: 26px;
      left: 4px;
      bottom: 4px;
      background-color: white;
      transition: 0.4s;
    }
  }
`;

const FieldBlockTerms = styled.div.attrs({
  className: "field_block field_block_accepted_terms"
})`
  .terms-link {
    a,
    a:visited,
    a:hover {
      color: ${props => props.bg};
    }
  }
`;

const SwitchError = styled.div`
  position: absolute;
  right: 0;
  bottom: 2px;
  display: block;
  right: -5px;
  height: 39px;
  top: calc(100%);
  font-size: 14px !important;
  width: 260px;
  padding: 10px 8px 10px 17px;
  color: #d50525 !important;
  background: #fff;
  border-radius: 2px;
  z-index: 2;
  &:before {
    position: absolute;
    content: "";
    bottom: 100%;
    right: 15px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 11px 10px;
    border-color: transparent transparent #ffffff transparent;
  }
`;

class Tab0 extends Component {
  state = {
    emailError: false,
    acceptedTermsError: false
  };
  toggleAcceptedTerms = e => {
    this.setState({
      acceptedTermsError: e.target.checked ? false : true
    });
    this.props.updateInput({ name: "acceptedTerms", value: e.target.checked });
  };
  updateInput = data => {
    this.setState({
      [data.name + "Error"]: data.value !== "" ? false : true
    });
    this.props.updateInput(data);
  };
  moveToNextTab = () => {
    const { email, acceptedTerms } = this.props;

    const emailError = !isEmail(email) ? true : false;
    const acceptedTermsError = !acceptedTerms ? true : false;

    this.setState({
      emailError,
      acceptedTermsError
    });

    if (emailError || acceptedTermsError) {
      return;
    }

    this.props.moveToNextTab();
  };

  render() {
    const props = this.props;
    const state = this.state;
    return (
      <Container>
        <div style={{ flexGrow: 1 }} className="form_steps test_tab0">
          <div className="form_steps--inner flex">
            <div className="form_steps--column">
              <div className="full_column">
                <Logo />
                <div className="form_content">
                  <h2 className="form_content--title">{props.domain.Strings.tab0Title}</h2>

                  <div className="fields_container">
                    <div className={classNames("field_block field_block--fill", { error: state.emailError })}>
                      <label> {props.domain.Strings.tab0EmailLabel}</label>
                      <Input value={props.email} onChange={this.updateInput} name="email" type="email" className="test_tab0EmailInput" cla />
                      {state.emailError && <InputError label={props.domain.Strings.tab0EmailError} />}
                    </div>

                    <FieldBlockTerms bg={props.domain.BaseColour}>
                      <div className="terms-link" dangerouslySetInnerHTML={{ __html: props.domain.Strings.tab0AgreeToTerms }} />
                      <Switch bg={props.domain.BaseColour}>
                        <input onChange={this.toggleAcceptedTerms} checked={props.acceptedTerms} type="checkbox" />
                        <span className="slider test_slider" />
                        {state.acceptedTermsError && <SwitchError>{props.domain.Strings.tab0TermsError}</SwitchError>}
                      </Switch>
                    </FieldBlockTerms>
                    <div className="checkbox_container--content">
                      <p>{props.domain.Strings.tab0NonCommitMsg}</p>
                    </div>
                    <NextStepButton text={props.domain.Strings.tab0NextButton} onClick={this.moveToNextTab} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Banner bg={this.props.domain.BaseColour}>
          <div>
            <h2>{props.domain.Strings.tab0BigHeader}</h2>
          </div>
          <div>
            <h4>{props.domain.Strings.tab0SubHeader}</h4>
          </div>
        </Banner>
      </Container>
    );
  }
}
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateInput: ({ name, value }) => dispatch({ type: UPDATE_INPUT, name, value }),
    moveToNextTab: () => dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab0);

const Banner = styled.div`
  background: ${props => props.bg};

  color: #fff;
  display: flex;
  flex-grow: 1.5 !important;

  justify-content: center;
  flex-direction: column;

  @media only screen and (max-width: 900px) {
    display: none;
  }
  @media only screen and (max-width: 1400px) {
    flex-grow: 1;
  }

  h2 {
    margin-top: 83px;
    font-size: 64px;
    margin-left: 100px;
    margin-bottom: 20px;
  }
  h4 {
    margin-left: 100px;
    font-size: 34px;
  }
`;

const Container = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: row;

  & > div {
   
    flex-basis: 0;
    height:100%:
    
  }

  div.form_steps {
    padding:40px 0px !important;
    div.form_steps--inner {
      padding:23px 0px !important;
      div.form_steps--column{
        flex-basis:80%;
        div.full_column{
        //  padding:20px 0px !important;
        }
      }
    }
  }
  div.form_steps {
    padding:40px 0px !important;
    div.form_steps--inner {
      padding:23px 0px !important;
      div.form_steps--column{
        flex-basis:80%;
        div.full_column{
        //  padding:20px 0px !important;
        }
      }
    }
  }
`;
